import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

interface I_Sources {
  page: string;
  source: string;
  text: string;
}

// Define a showSources for the slice state
interface showSourcesState {
  show: boolean;
  index: number;
  sourcesArray: I_Sources[];
}

// Define the initial state using that showSources
const initialState: showSourcesState = {
  show: false,
  index: 0,
  sourcesArray: [],
};

export const showSourcesSlice = createSlice({
  name: "showSources",
  // `createSlice` will infer the state showSources from the `initialState` argument
  initialState,
  reducers: {
    addshowSources: (state, action) => {
      state.show = true;
      state.index = action.payload.index;
      state.sourcesArray = action.payload.sources;
    },
    removeshowSources: (state) => {
      state.show = false;
      state.index = 0;
      state.sourcesArray = [];
    },
    changeIndex: (state, action) => {
      return {
        ...state,
        index: action.payload,
      };
    },
  },
});

export const { addshowSources, removeshowSources, changeIndex } =
  showSourcesSlice.actions;

// Other code such as selectors can use the imported `RootState` showSources

export const getshowSources = (state: RootState) => state.showSources;

export default showSourcesSlice.reducer;
